import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-[100px] sm:pt-[120px] lg:pt-[140px]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
